import { Component, Input, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { tr } from "@util/tr";
import { WsNavigatorService } from "@web/app/services/ws-navigator.service";
import { access } from "@util/route/access";

@Component({
  selector: "ws-page-header",
  templateUrl: "./ws-page-header.component.html",
  styleUrls: ["./ws-page-header.component.scss"],
})
export class WsPageHeaderComponent implements OnInit {
  @Input() title: string = "";
  @Input() icon: string | undefined = "";

  constructor(
    private location: Location,
    private router: Router,
    private wsNavitorService: WsNavigatorService
  ) {}

  ngOnInit() {
    this.wsNavitorService.navigationState$.subscribe((state) => {
      this.title = state.title;
      this.icon = state.icon || undefined;
    });
  }

  //private updateHeader() {
  //  // Get the current path without query parameters and remove trailing slashes
  //  let path = this.router.url.split('?')[0].replace(/\/$/, '');
  //  const segments = path.split('/').filter(segment => segment);
  //
  //  if (segments.length === 0) {
  //    this.title = ''; // Home page, no title
  //  } else {
  //    const mainSegment = segments[0]; // First segment is the main page
  //    const lastSegment = segments[segments.length - 1]; // Last segment is the current page
  //
  //    // Get config from map, fallback to segment name
  //    const config = this.pageConfigMap[mainSegment];
  //
  //    if(!!!config){
  //      this.title = ''; // Home page, no title
  //    } else {
  //      this.title = tr(config.title);
  //    }
  //  }
  //}

  goBack(): void {
    this.location.back();
  }

  showHeader(): boolean {
    return !!!!this.title && this.title !== "";
  }
}
